export const FETCH_MOBILE_TASKS_REQUEST =
  'mobileTasks/FETCH_MOBILE_TASKS_REQUEST'
export const FETCH_MOBILE_TASKS_SUCCESS =
  'mobileTasks/FETCH_MOBILE_TASKS_SUCCESS'
export const FETCH_MOBILE_TASKS_FAILURE =
  'mobileTasks/FETCH_MOBILE_TASKS_FAILURE'

export const AUTOASSIGN_TASKS_REQUEST = 'mobileTasks/AUTOASSIGN_TASKS_REQUEST'
export const AUTOASSIGN_TASKS_SUCCESS = 'mobileTasks/AUTOASSIGN_TASKS_SUCCESS'
export const AUTOASSIGN_TASKS_FAILURE = 'mobileTasks/AUTOASSIGN_TASKS_FAILURE'

export const UPDATE_FIELD = 'mobileTasks/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'mobileTasks/SET_DEFAULT_DATA'
